import { css } from 'styled-components';

export default css`
  &.filter-pill-form-container {
    /* margin-top: 25px; */
  }
  .scrollPill {
    display: flex;
    overflow-x: scroll;
    height: 43px;
    padding-bottom: 10px;
  }
  .scrollPill::-webkit-scrollbar {
    height: 0px;
  }
  .filter-pill {
    margin: 0px 12px 0px 0px;
  }
  .search-close-icon {
    width: 12px;
  }
  .count-section {
    padding-top: 24px;
  }
  .show-label {
    display: none;
  }
  .hideModal {
    visibility: hidden;
  }
  .filter-pill.upperText .pill-text {
    text-transform: lowercase;
  }
  .filter-pill.upperText .pill-text:first-letter {
    text-transform: uppercase;
  }
  .filterTextPill.filter-pill .pill-button {
    background: ${(props) => props.theme.colorPalette.blue.C900};
    width: 106px;
  }
  .filterTextPill.filter-pill .pill-text {
    color: ${(props) => props.theme.colors.WHITE};
  }
  .custom-filter-form {
    padding: 0px 25px;
    z-index: -1;

    @media ${(props) => props.theme.mediaQuery.large} {
    ${props => props.isHPLP ? 'padding: 0;': ''}
    }
  }
  .custom-filter-form .filter-redesign {
    width: auto;
    border-right: 0px;

    @media ${(props) => props.theme.mediaQuery.large} {
      ${props => props.isHPLP ? 'padding: 0 18px;max-height: calc(100vh - 155px);height: calc(100vh - 155px);': ''}
    }
  }
  .activeTextPill.filter-pill .pill-button {
    background: ${(props) => props.theme.colorPalette.blue.C900};
  }
  .activeTextPill.filter-pill .pill-text {
    color: ${(props) => props.theme.colors.WHITE};
  }
  @media (min-device-width: 360px) and (max-device-width: 767px) {
    .filter-form-cnt .filter-redesign {
      height: 50vh;
      padding: 7px 14px;
      overflow-x: hidden;
    }
  }
  @media (min-device-width: 768px) and (max-device-width: 1200px) {
    .custom-filter-form {
      padding: 25px 9px;
    }
    .custom-filter-form .bopis-filter-wrapper {
      height: 75px;
    }
    .custom-filter-form .filter-redesign {
      height: calc(100vh - 160px);
      max-height: calc(100vh - 160px);
    }
    .custom-filter-form .store-info {
      display: block;
    }
    .store-change-wrapper {
      margin-left: 0px !important;
    }
  }
  @media (min-device-width: 320px) and (max-device-width: 1200px) {
    .custom-filter-form .bopis-filter-wrapper {
      display: none;
    }
    .mobileBopisFilter {
      margin-bottom: 14px;
    }
  }
`;

export const customHeaderStyle = css`
  div.TCPModal__InnerContent {
    padding: 0;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 0px ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      padding: 0px ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
  }
  .Modal_Heading {
    border-bottom: none;
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    font-size: ${(props) => props.theme.typography.fontSizes.fs22};
    display: flex;
    justify-content: center;
    height: auto;
    margin-bottom: 0px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: flex;
      justify-content: center;
      height: auto;
    }
  }
  .close-modal {
    height: 14px;
    right: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    @media ${(props) => props.theme.mediaQuery.medium} {
      right: 0px;
    }
  }
`;
